import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Registration from './component/Registration';
import Error from './Pages/Error';

const router = createBrowserRouter([
  {
    path: "/public/metDentalRegistration",
    element: <Registration />,
  },
  {
    path: "/public/registrationContactSupport",
    element: <Error />
  },
  {
    path: "/*",
    element: <Error />
  }
]);

const AppRouter = () => {
  return <RouterProvider router={router} />;
};

export default AppRouter;